import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './style.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');

// Pequeño helper global para depurar en producción si hace falta.
if (import.meta.env.DEV) {
  // @ts-expect-error: solo en dev
  window.__foxboxApp = app;
}
